// Borrower
export const mockBorrowerUserAuthContext = {
  status: 'logged-in' as const,
  accessToken: {
    raw: '<access token>',
    payload: {
      id: '193e80e3-c90e-4c9e-b387-8ec0cdb0dae5',
      email: 'borrower@test.com',
      userType: 'BORROWER' as const,
    },
  },
  user: {
    id: '193e80e3-c90e-4c9e-b387-8ec0cdb0dae5',
    userType: 'BORROWER' as const,
    email: 'borrower@test.com',
    isActive: true,
    organizationId: 'mock-borrower-id',
    roleType: 'ADMIN' as const,
    firstName: 'Gordon',
    lastName: 'Freeman',
    organization: {
      id: 'ffff1234-90c4-463f-8c09-a325981c1dd5',
      industry: 'Corporate Credit Cards',
      name: 'Borrower Corp',
      slug: 'borrowerCorp',
    },
  },
  error: null,
};

// Capital provider
export const mockCapitalProviderUserAuthContext = {
  status: 'logged-in' as const,
  accessToken: {
    raw: '<access token>',
    payload: {
      id: '96a6e1e5-1138-4009-98ad-6d3b728f370d',
      email: 'capital-provider@test.com',
      userType: 'CAPITAL_PROVIDER' as const,
    },
  },
  user: {
    id: '96a6e1e5-1138-4009-98ad-6d3b728f370d',
    userType: 'CAPITAL_PROVIDER' as const,
    email: 'capital-provider@test.com',
    isActive: true,
    organizationId: 'mock-capital-provider-id',
    roleType: 'ADMIN' as const,
    firstName: 'Alyx',
    lastName: 'Vance',
    organization: {
      id: 'eeb58930-2da7-4973-9e6f-87b201667202',
      industry: 'Private Credit',
      name: 'Capital Provider Corp',
      slug: 'capitalProviderCorp',
    },
  },
  error: null,
};

// Logged out
export const mockLoggedOutUserAuthContext = {
  status: 'logged-out' as const,
  accessToken: null,
  user: null,
  error: null,
};
